import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafeHtmlPipe } from 'src/app/pipes/safe-html.pipe';
import { MaxPipe } from 'src/app/pipes/max.pipe';
import { FormatDuracaoPipe } from 'src/app/pipes/format-duracao.pipe';
import { DateFormatTextPipe } from 'src/app/pipes/date-format-text.pipe';
import { TipoPassageiroDescPipe } from 'src/app/pipes/tipo-passageiro-desc.pipe';
import { FormatDiasPipe } from '../../pipes/format-dias.pipe';
import { GetTarifaMinimaListaPipe } from 'src/app/pipes/get-tarifa-minima-lista.pipe';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { FormatValorManagerPipe } from 'src/app/pipes/format-valor-manager.pipe';
import { EventoDateFormatPipe } from 'src/app/pipes/evento-date-format.pipe';
import { CategoryHotelPipe } from 'src/app/pipes/category-hotel.pipe';

@NgModule({
  declarations: [
    SafeHtmlPipe,
    MaxPipe,
    DateFormatTextPipe,
    FormatDuracaoPipe,  
    TipoPassageiroDescPipe, 
    FormatDiasPipe,
    GetTarifaMinimaListaPipe,
    TranslatePipe,
    FormatValorManagerPipe,
    EventoDateFormatPipe,
    CategoryHotelPipe
  ],
  exports: [
    SafeHtmlPipe,
    MaxPipe,
    FormatDuracaoPipe,
    DateFormatTextPipe,
    TipoPassageiroDescPipe,
    FormatDiasPipe,
    GetTarifaMinimaListaPipe,
    TranslatePipe,
    FormatValorManagerPipe,
    EventoDateFormatPipe,
    CategoryHotelPipe
  ],
  imports: [
    CommonModule
  ]
})
export class PipeModule{}
